<template>
  <div class="asset-detail">

    <!-- 第一部分：导航栏 -->
    <header class="header">
      <div class="nav-container">
        <div class="logo-container">
          <img src="@/assets/img/logoNew.png" class="logo-img" alt="平台logo">
          <span class="logo-text">数据资产全过程AI服务平台</span>
        </div>
        <nav class="nav-links">
          <router-link to="/">官网首页</router-link>
          <router-link to="/infoPublic">信息公示</router-link>
          <router-link to="/about">关于平台</router-link>
        </nav>
        <div class="auth-buttons">
          <template v-if="!isLoggedIn">
            <router-link to="/login" class="login-btn">登录</router-link>
            <router-link to="/register" class="register-btn">注册</router-link>
          </template>
          <template v-else>

            <div class="user-avatar" @click="handleAvatarClick">
              <img :src="avatarUrl" alt="用户头像">
            </div>
          </template>
        </div>
      </div>
    </header>

    <!-- 第二部分：主标题区 -->
    <section class="hero">
      <div class="hero-content">
        <h1 class="hero-title">数据资产登记公示</h1>
        <p class="hero-subtitle1">&nbsp;&nbsp;&nbsp;&nbsp;平台面向企业用户，对合法取得的数据资源或数据产品提供登记、变更、转移、审核、</p>
        <p class="hero-subtitle1">颁发证书等功能。</p>

      </div>
    </section>


    <!-- 主要内容区 -->
    <div class="info-container">
      <!-- 搜索框部分 - 嵌入到主标题区下方 -->
      <div class="search-container">
        <div class="search-bar">
          <el-select v-model="searchType" placeholder="请选择查询方式" class="search-select">
            <el-option label="资产名称" value="assetName"></el-option>
            <el-option label="登记编号" value="registrationId"></el-option>
          </el-select>
          <el-input v-model="searchValue" placeholder="请输入关键字" class="search-input"
            @keyup.enter="handleSearch"></el-input>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>

      <h1 class="page-title">数据资产登记公示</h1>
      <div class="data-cards" v-if="dataList.length > 0">
        <el-row :gutter="10">
          <el-col :span="12" v-for="(item, index) in dataList" :key="index">
            <div class="card-content" :class="getCardClass(item.state)"
              @click="$router.push(`/assetDetail/${item.registrationId}`)">
              <div class="asset-name">{{ item.assetName }}</div>
              <div class="card-info">
                <p><span class="label-text">申请主体:</span><span class="value-text">{{ item.companyName }}</span></p>
                <p>
                  <span class="label-text">登记编号:</span>
                  <span class="value-text">{{ item.registrationId }}</span>
                  <span class="card-date">登记日期：{{ item.registrationDate }}</span>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="no-data" v-else>
        <el-empty description="暂无公示信息数据"></el-empty>
      </div>

      <el-pagination v-if="dataList.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" :page-sizes="[6, 10, 20, 30, 50]" class="pagination">
      </el-pagination>
    </div>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <p class="footer-title">数据资产全过程AI服务平台</p>
          <p>邮箱: yuanshuqiang@xinxiusz.com</p>
          <p>联系电话: 15831289727</p>
          <p>地址: 保定市竞秀区时代路数字大厦一楼</p>
        </div>
        <div class="footer-section">
          <div class="footer-links">
            <router-link to="/" class="footer-link">官网首页</router-link>
            <router-link to="/infoPublic" class="footer-link">信息公示</router-link>
            <router-link to="/about" class="footer-link">关于平台</router-link>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© 2025 数据资产全过程AI服务平台 版权所有 隐私政策 冀ICP备2025125156号</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'InfoPublic',
  data() {
    return {
      searchType: 'assetName',
      searchValue: '',
      dataList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      isLoggedIn: false,
      pageSizes: [10, 20, 30, 50]
    }
  },
  created() {
    this.checkLoginStatus();
    this.setupLoginListener();
    this.fetchData();
  },
  methods: {

    handleAvatarClick() {
      this.$router.push('/home');
    },

    async fetchData() {
      try {
        //console.log('正在获取数据，页码:', this.currentPage, '每页条数:', this.pageSize);
        const params = {
          currPage: this.currentPage,
          pageSize: this.pageSize,
          [this.searchType]: this.searchValue || undefined
        };
        const res = await this.$axios.get('/web/page/certificate/queryPublicityListWithSize', {
          params,
          paramsSerializer: params => {
            return Object.entries(params)
              .filter(([_, value]) => value !== undefined)
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join('&');
          }
        });
        //console.log('获取数据成功:', res.data);
        this.dataList = res.data?.list || [];
        this.total = res.data?.total || 0;
      } catch (error) {
        console.error('获取公示数据失败:', error);
        this.$message.error('获取公示数据失败');
      }
    },

    checkLoginStatus() {
      const user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || 'null');
      this.isLoggedIn = !!user;
      if (user) {
        this.avatarUrl = user.avatar;
      }
      // 触发视图更新
      this.$forceUpdate();
    },
    setupLoginListener() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'user') {
          this.checkLoginStatus();
        }
      });
    },

    getCardClass(state) {
      if (state === '已颁发证书') {
        return 'issued';
      } else {
        return 'unissued';
      }
    },
    handleCurrentChange(val) {
      if (this.currentPage !== val) {
        this.currentPage = val;
        this.fetchData(); // 获取新页数据
      }
    },
    handleSizeChange(val) {
      if (this.pageSize !== val) {
        this.pageSize = val;
        this.currentPage = 1; // 重置到第一页
        this.fetchData(); // 重新获取数据
      }
    },
    handleSearch() {
      this.fetchData();
    },
    handleReset() {
      this.searchValue = '';
      this.fetchData();
    },
    goToDetail(registrationId) {
      this.$router.push({
        path: '/assetDetail',
        query: { registrationId }
      });
    }
  }
}
</script>

<style scoped>
/* 响应式布局 */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    padding: 10px;
  }

  .logo-container {
    flex-direction: column;
    text-align: center;
    margin-bottom: 15px;
  }

  .logo-text {
    font-size: 18px;
    margin-top: 5px;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
    margin: 10px 0;
  }

  .hero {
    padding: 60px 5%;
    text-align: center;
  }

  .hero-title {
    font-size: 28px;
  }

  .search-container {
    margin-top: -40px;
    padding: 0 5%;
  }

  .search-bar {
    flex-direction: column;
    gap: 10px;
    padding: 15px;
  }

  .search-select,
  .search-input {
    width: 100% !important;
  }

  .data-cards {
    margin: 20px 0;
  }

  .card-content {
    width: 100%;
    height: auto;
    padding: 15px;
  }

  .el-pagination {
    flex-wrap: wrap;
  }

  .footer-content {
    flex-direction: column;
  }

  .footer-section {
    margin-bottom: 20px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .logo-img {
    height: 30px;
  }

  .hero {
    padding: 40px 5%;
  }

  .hero-title {
    font-size: 24px;
  }

  .auth-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .login-btn,
  .register-btn,
  .user-center-btn {
    width: 100%;
    text-align: center;
  }

  .page-title {
    font-size: 24px;
  }

  .card-content {
    background-size: cover;
    height: 120px;
  }

  .asset-name {
    font-size: 16px;
  }

  .card-info p {
    font-size: 12px;
  }
}

.asset-detail {
  font-family: 'Microsoft YaHei', sans-serif;
  color: #536a6b;
  background-color: #ffffff;
  position: relative;
  width: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 2000px;
  overflow-x: auto;
}

/* 主标题区样式 - 参考CompanyHome.vue */
.hero {
  background: url('../../assets/img/home_header_bg.png') no-repeat center center;
  background-size: cover;
  padding: 100px 5%;
  display: flex;
  align-items: center;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  text-align: left;
}

.hero-title {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.hero-subtitle1 {
  font-size: 18px;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
}

.hero-subtitle2 {
  font-size: 18px;
  margin-bottom: 40px;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
}

.cta-button {
  display: inline-block;
  background: #1E88E5;
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
}

.asset-name-section {
  text-align: center;
  margin-bottom: 30px;
}

.asset-name {
  font-size: 26px;
  color: #050708;
  font-weight: normal;
}

.detail-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.detail-card>>>.el-card__header {
  background-color: #e2e4e7;
  color: rgb(1, 1, 1);
  font-size: 16px;
  font-weight: 100;
  border-radius: 8px 8px 0 0;
}

.detail-card>>>.el-descriptions__title {
  font-size: 14px;
  color: #606266;
}

.detail-card>>>.el-descriptions-item__label {
  font-size: 16px;
  color: #000000;
  background-color: #fcfcfc;
  width: 150px;
}

.detail-card>>>.el-descriptions-item__content {
  font-size: 16px;
  color: #6b6b6b;
  background-color: #ffffff;
}



.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  /* 确保靠左对齐 */
}

.logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 25px;
  font-weight: normal;
  color: #000000;
}

.nav-links {
  display: flex;
  gap: 80px;
  /* 将间距从30px增加到60px */
  margin: 0 auto;
  /* 保持居中 */
}

.nav-links a {
  color: #333;
  text-decoration: none;
  position: relative;
}

.nav-links a.router-link-exact-active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #1E88E5;
}


.auth-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}

.user-center-btn {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid #1E88E5;
  color: #1E88E5;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  margin-right: 10px;
  transition: all 0.3s;
}

.user-center-btn:hover {
  background: rgba(30, 136, 229, 0.1);
}

.user-avatar {
  display: flex;
  align-items: center;
}

.user-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.user-avatar img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.login-btn {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid #1E88E5;
  color: #1E88E5;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.register-btn {
  padding: 8px 20px;
  background: #1E88E5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.main-content {
  padding: 40px 5%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
}


.section {
  margin-bottom: 40px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #1E88E5;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.info-table {
  width: 100%;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-label {
  width: 150px;
  font-weight: bold;
  color: #666;
}

.info-value {
  flex: 1;
}

.info-grid {
  display: flex;
  gap: 40px;
}

.info-col {
  flex: 1;
}

.view-link {
  color: #1E88E5;
  text-decoration: none;
}

.description {
  margin-top: 20px;
}

.description h3 {
  margin-bottom: 10px;
  font-size: 18px;
}

.qr-code {
  text-align: center;
  margin-top: 20px;
}

.qr-code img {
  width: 200px;
  height: 200px;
}

/* 主要内容区 */
.info-container {
  padding: 80px 12%;
  text-align: center;
  width: auto;
  min-width: 2000px;
  margin: 0 auto;
  box-sizing: border-box;
  flex: 1;
}

.page-title {
  font-size: 32px;
  margin: 0 0 40px;
  color: #333;
  text-align: center;
  padding-bottom: 1px;
  position: relative;
}

.page-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #1E88E5;
}

.search-container {
  position: relative;
  margin-top: -60px;
  z-index: 1;
  padding: 0 10%;
  margin-bottom: 60px;
}

.search-bar {
  width: 80%;
  margin: 0 auto;
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

.search-bar {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 550px;
}

.search-select {
  width: 100px;
  height: 40px;
}

.search-select>>>.el-select {
  width: 100%;
}

.search-select>>>.el-input__inner {
  text-align: left;
  padding: 0 12px;
  font-size: 14px;
}

.search-select>>>.el-select-dropdown__item {
  text-align: center;
  padding: 0 5px;
  font-size: 14px;
}

.search-input {
  width: 260px;
}

.search-input>>>.el-input__inner {
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-size: 14px;
}

.el-button {
  padding: 10px 18px;
  border-radius: 4px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  min-width: 70px;
  font-size: 14px;
}

.el-button+.el-button {
  margin-left: 6px;
}

.el-button--primary {
  background-color: #1E88E5;
  border-color: #1E88E5;
  transition: all 0.3s;
}

.el-button--primary:hover {
  background-color: #1565C0;
  border-color: #1565C0;
}

.el-button--default {
  background-color: #fff;
  border-color: #dcdfe6;
  transition: all 0.3s;
}

.el-button--default:hover {
  border-color: #1E88E5;
  color: #1E88E5;
}

.el-button--primary {
  background-color: #1E88E5;
  border-color: #1E88E5;
}

.el-button--default {
  background-color: #fff;
  border-color: #dcdfe6;
}

.data-cards {
  margin: 40px 0;
  padding: 0;
}

.card-content {
  font-size: 14px;
  padding: 20px;
  background-image: url('../../assets/img/home_pub3.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 682px;
  height: 90px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-content.issued {
  background-image: url('../../assets/img/home_pub3.png');
}

.card-content.unissued {
  background-image: url('../../assets/img/home_pub3_un.png');
}


/*莹光属性 去掉:hover，文字直接生效*/
.card-content:hover>* {
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}

.data-card {
  margin-bottom: 25px;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  cursor: pointer;
}

.data-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}



.card-content:hover {
  transform: scale(1.02);
}

.asset-name {
  font-size: 17px;
  font-weight: normal;
  margin-top: -5;
  margin-bottom: 10px;
  text-align: left;
  color: #000000;
  padding-top: 1px;
}

.card-info {
  text-align: left;
  margin-bottom: 10px;
}

.card-info p {
  display: flex;
  align-items: center;
  color: #fff;
  margin: 5px 0;
}

.card-date {
  margin-left: auto;
  color: #3864dd;
  font-weight: bold;
}



.value-text {
  color: #fff;
}

/* 导航栏 */
.header {
  background-color: #EEF1F9;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 5%;
}

.card-body {
  flex: 1;
  text-align: left;
  padding: 12px 0;
}

.card-body p {
  margin: 12px 0;
  color: #333;
  font-size: 15px;
  line-height: 1.5;
}

.label-text {
  color: #888;
  font-weight: 500;
  margin-right: 20px;
}

.value-text {
  color: #333;
  font-weight: normal;
}

.card-footer {
  text-align: right;
  margin-top: auto;
  color: #1E88E5;
  font-size: 14px;
  font-weight: 500;
  padding-top: 12px;
}

.el-col {
  margin-bottom: 20px;
  padding: 0 10px;
  display: flex;
  justify-content: center;
}

.el-row {
  margin: 0 -10px;
  justify-content: center;
}


.label {
  color: #333;
  font-weight: 500;
  display: inline-block;
  width: 80px;
}

.el-row {
  margin-bottom: -20px;
}

.el-col {
  margin-bottom: 20px;
}

.no-data {
  margin-top: 50px;
}

.pagination {
  margin-top: 30px;
  justify-content: center;
}

/* 分页样式优化 */
.el-pagination {
  --el-pagination-button-width: 32px;
  --el-pagination-button-height: 32px;
  --el-pagination-font-size: 14px;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  margin: 0 4px;
  min-width: 32px;
  border-radius: 4px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1E88E5;
  color: white;
  font-weight: bold;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #1E88E5;
}

.el-pagination__jump {
  margin-left: 10px;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  /* 确保靠左对齐 */
}

.logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 25px;
  font-weight: normal;
  color: #000000;
}

.footer {
  background: #245a97;
  color: white;
  padding: 40px 5% 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  margin: 10px 0;
  flex-basis: 30%;
}

.footer-title {
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 20px;
  color: #ffffff;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer a,
.footer .footer-link {
  color: white;
  text-decoration: none;
  margin-right: 10px;
  font-size: 14px;
  display: block;
  margin-bottom: 8px;
}

.footer a:hover,
.footer .footer-link:hover {
  text-decoration: underline;
}

.footer .router-link-active {
  font-weight: bold;
}

.footer-bottom {
  text-align: center;
  width: 100%;
  margin-top: 30px;
  font-size: 12px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

@media (max-width: 768px) {
  .footer-section {
    flex-basis: 100%;
    margin-bottom: 20px;
  }
}
</style>
